import { createTheme } from 'flowbite-react';
import { theme as input } from '../Text/theme';

const items = {
    item: {
        selected: 'bg-primary-700 text-white hover:bg-primary-600',
    },
};

export const theme = createTheme({
    datepicker: {
        root: {
            input,
        },
        popup: {
            footer: {
                button: {
                    today: 'bg-primary-700 text-white hover:bg-primary-800',
                },
            },
        },
        views: {
            days: {
                items,
            },
            months: {
                items,
            },
            years: {
                items,
            },
            decades: {
                items,
            },
        },
    },
}).datepicker;
